import React, { useState } from 'react';
import { Star, X } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function RatingModal({ user, matchId, onClose, onSuccess }) {
  const [ratings, setRatings] = useState({
    confiance: 0,
    serieux: 0,
    generosite: 0,
    comportement: 0,
    communication: 0
  });
  const [loading, setLoading] = useState(false);

  const criteria = [
    { key: 'confiance', label: 'Confiance', description: 'Niveau de confiance' },
    { key: 'serieux', label: 'Sérieux', description: 'Fiabilité et engagement' },
    { key: 'generosite', label: 'Générosité', description: 'Ouverture et partage' },
    { key: 'comportement', label: 'Comportement', description: 'Attitude générale' },
    { key: 'communication', label: 'Communication', description: 'Qualité des échanges' }
  ];

  const handleRatingClick = (criterion, value) => {
    setRatings(prev => ({ ...prev, [criterion]: value }));
  };

  const handleSubmit = async () => {
    // Check all criteria are rated
    const allRated = Object.values(ratings).every(r => r > 0);
    if (!allRated) {
      toast.error('Veuillez noter tous les critères');
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      await axios.post(
        `${API}/ratings/submit`,
        {
          rated_user_id: user.id,
          match_id: matchId,
          ...ratings
        },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      toast.success('Notation enregistrée avec succès !');
      onSuccess?.();
      onClose();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur lors de la notation');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl p-6 max-w-md w-full max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-bold text-gray-800">Noter {user.name}</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <p className="text-gray-600 mb-6">
          Votre note est <strong>anonyme</strong> et aide la communauté.
        </p>

        <div className="space-y-6">
          {criteria.map((criterion) => (
            <div key={criterion.key} className="border-b border-gray-100 pb-4 last:border-0">
              <div className="mb-2">
                <h3 className="font-semibold text-gray-800">{criterion.label}</h3>
                <p className="text-sm text-gray-500">{criterion.description}</p>
              </div>
              <div className="flex gap-2">
                {[1, 2, 3, 4, 5].map((star) => (
                  <button
                    key={star}
                    onClick={() => handleRatingClick(criterion.key, star)}
                    className="transition-transform hover:scale-110"
                  >
                    <Star
                      className={`w-8 h-8 ${
                        star <= ratings[criterion.key]
                          ? 'fill-yellow-400 text-yellow-400'
                          : 'text-gray-300'
                      }`}
                    />
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="flex gap-3 mt-6">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-3 border border-gray-300 rounded-xl hover:bg-gray-50 transition-colors"
            disabled={loading}
          >
            Annuler
          </button>
          <button
            onClick={handleSubmit}
            className="flex-1 px-4 py-3 btn-primary rounded-xl"
            disabled={loading}
          >
            {loading ? 'Envoi...' : 'Valider'}
          </button>
        </div>
      </div>
    </div>
  );
}
